<div [sq-action-buttons]="{
        items: [exportAction],
        autoAdjust: true,
        rightAligned: rightAligned
    }">
</div>